import PrivateRoute from '../../routes/privateRoute';
import React from 'react';

const Dashboard = React.lazy(() => import('./views/Dashboard'));

const dashboardRoutes = {
    path: '/dashboard',
    name: 'Dashboard',
    icon: 'dripicons-graph-pie',
    component: Dashboard,
    show: false,
    route: PrivateRoute,
};

export default dashboardRoutes;